import {
  LayoutDashboard,
  Wallet,
  BarChart3,
  Shield,
  Building2,
  FileText,
  Settings,
  MessageSquare,
  Crown,
  Box,
  Briefcase,
  ReceiptText,
  Receipt,
  Tractor
} from 'lucide-react';
import { Video as LucideIcon } from 'lucide-react';

export interface UserNavItem {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
  requiresAccess?: 'budget' | 'security' | 'associations' | 'modules' | 'reports' | 'daf' | 'pme' | 'agri';
}

export interface UserNavSection {
  id: string;
  label: string;
  items: UserNavItem[];
}

export const USER_NAV_SECTIONS: UserNavSection[] = [
  {
    id: 'main',
    label: 'Principal',
    items: [
      {
        id: 'dashboard',
        label: 'Tableau de bord',
        path: '/app',
        icon: LayoutDashboard,
      },
      {
        id: 'treasury',
        label: 'Trésorerie',
        path: '/app/treasury',
        icon: Wallet,
      },
      {
        id: 'bank',
        label: 'Banque',
        path: '/app/bank',
        icon: Building2,
      },
    ],
  },
  {
    id: 'financial',
    label: 'Gestion financière',
    items: [
      {
        id: 'budget',
        label: 'Budget',
        path: '/app/budget',
        icon: BarChart3,
        requiresAccess: 'budget',
      },
      {
        id: 'security',
        label: 'Sécurité',
        path: '/app/security',
        icon: Shield,
        requiresAccess: 'security',
      },
      {
        id: 'grants',
        label: 'Associations',
        path: '/app/grants',
        icon: FileText,
        requiresAccess: 'associations',
      },
    ],
  },
  {
    id: 'tools',
    label: 'Outils',
    items: [
      {
        id: 'modules',
        label: 'Modules métiers',
        path: '/app/modules',
        icon: Box,
        requiresAccess: 'modules',
      },
      {
        id: 'rapports',
        label: 'Rapports',
        path: '/app/rapports',
        icon: FileText,
        requiresAccess: 'reports',
      },
      {
        id: 'daf',
        label: 'Espace DAF',
        path: '/app/daf',
        icon: Crown,
        requiresAccess: 'daf',
      },
    ],
  },
  {
    id: 'agri',
    label: 'Agriculture',
    items: [
      {
        id: 'agri',
        label: 'Exploitation agricole',
        path: '/app/agri',
        icon: Tractor,
        requiresAccess: 'agri',
      },
    ],
  },
  {
    id: 'pme',
    label: 'PME',
    items: [
      {
        id: 'pme-dashboard',
        label: 'Cockpit PME',
        path: '/app/pme',
        icon: Briefcase,
        requiresAccess: 'pme',
      },
      {
        id: 'pme-invoices',
        label: 'Factures clients',
        path: '/app/pme/invoices',
        icon: ReceiptText,
        requiresAccess: 'pme',
      },
      {
        id: 'pme-expenses',
        label: 'Charges fixes',
        path: '/app/pme/expenses',
        icon: Receipt,
        requiresAccess: 'pme',
      },
    ],
  },
  {
    id: 'account',
    label: 'Mon compte',
    items: [
      {
        id: 'support',
        label: 'Support',
        path: '/app/support',
        icon: MessageSquare,
      },
      {
        id: 'settings',
        label: 'Paramètres',
        path: '/app/settings',
        icon: Settings,
      },
    ],
  },
];
